__turbopack_context__.v({
  "arrow": "STCareer-module__6k8xOa__arrow",
  "badge": "STCareer-module__6k8xOa__badge",
  "heroImgWrapper": "STCareer-module__6k8xOa__heroImgWrapper",
  "heroSection": "STCareer-module__6k8xOa__heroSection",
  "heroTextWrapper": "STCareer-module__6k8xOa__heroTextWrapper",
  "jobCard": "STCareer-module__6k8xOa__jobCard",
  "jobHeadingWrapper": "STCareer-module__6k8xOa__jobHeadingWrapper",
  "pill": "STCareer-module__6k8xOa__pill",
  "pillWrapper": "STCareer-module__6k8xOa__pillWrapper",
});
